import {
  AppointmentRepoImpl,
  AuthRepoImpl,
  ChatRepoImpl,
  CouponRepoImpl,
  FinancialRepoImpl,
  NotificationRepoImpl,
  PatientRepoImpl,
  PaymentRepoImpl,
  RatingRepoImpl,
  ScheduleRepoImpl,
  SettingsRepoImpl,
  SharedAppointmentSlotRepoImpl,
  SubsRepoImpl,
  UserRepoImpl,
} from "@phurshell/psiapp-frontend-core/data";
import {
  appointmentDataSource,
  authDataSource,
  chatDataSource,
  couponDataSource,
  financialDataSource,
  notificationDataSource,
  patientDataSource,
  paymentDataSource,
  ratingDataSource,
  scheduleDataSource,
  settingsDataSource,
  sharedAppointmentSlotDataSource,
  subsDataSource,
  userDataSource,
} from "./datasources";
import {
  appointmentMapper,
  chatMapper,
  couponMapper,
  financialMapper,
  notificationMapper,
  patientMapper,
  paymentMapper,
  planMapper,
  scheduleMapper,
  subsMapper,
  userMapper,
} from "./mappers";

export const authRepo = new AuthRepoImpl(authDataSource);
export const userRepo = new UserRepoImpl(userDataSource, userMapper);
export const appointmentRepo = new AppointmentRepoImpl(
  appointmentDataSource,
  appointmentMapper,
);
export const financialRepo = new FinancialRepoImpl(
  financialDataSource,
  financialMapper,
);
export const chatRepo = new ChatRepoImpl(chatDataSource, chatMapper);
export const subsRepo = new SubsRepoImpl(subsDataSource, subsMapper, planMapper);
export const paymentRepo = new PaymentRepoImpl(paymentDataSource, paymentMapper);
export const settingsRepo = new SettingsRepoImpl(settingsDataSource);
export const scheduleRepo = new ScheduleRepoImpl(scheduleDataSource, scheduleMapper);
export const notificationRepo = new NotificationRepoImpl(
  notificationDataSource,
  notificationMapper,
);
export const patientRepo = new PatientRepoImpl(patientDataSource, patientMapper);
export const ratingRepo = new RatingRepoImpl(ratingDataSource);
export const couponRepo = new CouponRepoImpl(couponDataSource, couponMapper);
export const sharedAppointmentSlotRepo = new SharedAppointmentSlotRepoImpl(
  sharedAppointmentSlotDataSource,
);

export const repos = {
  authRepo,
  userRepo,
  appointmentRepo,
  financialRepo,
  chatRepo,
  subsRepo,
  paymentRepo,
  settingsRepo,
  scheduleRepo,
  notificationRepo,
  patientRepo,
  ratingRepo,
  couponRepo,
  sharedAppointmentSlotRepo,
};
